import LoadableAttachmentList from './loadable_attachment_list'
import ReactComponent from 'lib/modulor/react_component'

ReactComponent.register(LoadableAttachmentList, 'Modulor.AttachmentList')
